import { produce } from 'immer';

//

// STATE
// =====

export function snapshot<S>(state :S) :S {
  return produce(state, (d) => d);
}
